//#region src/core/i18n/text/fullscreen.ts
const prefix = "fullscreen.";
const enterText = {
	key: `${prefix}enter`,
	text: "Enter fullscreen"
};
const exitText = {
	key: `${prefix}exit`,
	text: "Exit fullscreen"
};
//#endregion
export { enterText, exitText };

//# sourceMappingURL=fullscreen.js.map